
























import EpbButton from '../button.component.vue';
import TransitionHeight from '../transition-height.component.vue';

export default {
  name: 'insights-landing-card',
  props: {
    name: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    route: {
      type: Object, // Route
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    },
    hovered: Boolean,
    messages: {
      type: Object, // InsightsMessages['landing']['card']
      required: true
    }
  },
  components: {
    TransitionHeight,
    EpbButton
  },
  data: function () {
    return {
      baseClass: 'epb-insights-landing-card',
      defaultImageUrl: require('../../assets/media/image/image-not-found.svg')
    };
  },
  methods: {
    onImageError: function (event): void {
      event.target.src = this.defaultImageUrl;
    }
  }
};

